import { InternalProjectTypes } from '@cxstudio/internal-projects/internal-project-types.constant';
import { AnalyticMetricTypes } from '@cxstudio/report-filters/constants/analytic-metric-types';
import { WidgetProperties } from '@cxstudio/reports/entities/widget-properties';

export class WidgetSettingsUtils {
	static hasGroupingConfig = (props: WidgetProperties, grouping): boolean => 
		!InternalProjectTypes.isAdminProject(props.project) || AnalyticMetricTypes.isTime(grouping);
}